// src/Routes.jsx
import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";

// Page imports
// import Homepage from "pages/homepage";
// import PropertyListings from "pages/property-listings";
// import PropertyDetails from "pages/property-details";
import AgentDashboard from "pages/agent-dashboard";
import UserProfileSettings from "pages/user-profile-settings";
import WellnessRetreatHomepage from "pages/wellness-retreat-homepage";
import WellnessCenterListings from "pages/wellness-center-listings";
import EESCenterDetails from "pages/ees-center-details";
import WellnessHostDashboard from "pages/wellness-host-dashboard";
import WellnessUserProfile from "pages/wellness-user-profile";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* <Route path="/" element={<Homepage />} /> */}
          {/* <Route path="/homepage" element={<Homepage />} /> */}
          {/* <Route path="/property-listings" element={<PropertyListings />} /> */}
          {/* <Route path="/property-details" element={<PropertyDetails />} /> */}
          <Route path="/agent-dashboard" element={<AgentDashboard />} />
          <Route path="/user-profile-settings" element={<UserProfileSettings />} />
          <Route path="/homepage" element={<WellnessRetreatHomepage />} />
          <Route path="/" element={<WellnessRetreatHomepage />} />
          <Route path="/wellness-center-listings" element={<WellnessCenterListings />} />
          <Route path="/ees-center-details" element={<EESCenterDetails />} />
          <Route path="/wellness-host-dashboard" element={<WellnessHostDashboard />} />
          <Route path="/wellness-user-profile" element={<WellnessUserProfile />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;